// Theme-invariant tokens: identical in dark, light and ippon palettes, so
// consumers can import them instead of subscribing to the themeStyle store.
// Values mirror the `:export` block of dark-colors.module.scss.

export const borderRadiusXS = '2px'
export const borderRadiusXSCompact = '2px'
export const borderRadiusSM = '4px'
export const borderRadiusBase = '6px'
export const borderRadiusLG = '8px'
export const borderRadiusLGCompact = '8px'

export const sizeXXS = '4px'
export const sizeXS = '8px'
export const sizeSM = '12px'
export const sizeBase = '16px'
export const sizeMS = '16px'
export const sizeMD = '20px'
export const sizeLG = '24px'
export const sizeXL = '32px'
export const sizeXXL = '48px'

export const controlHeightXS = '16px'
export const controlHeightSM = '24px'
export const controlHeight = '32px'
export const controlHeightLG = '40px'

export const screenXS = '480px'
export const screenSM = '576px'
export const screenMD = '768px'
export const screenLG = '992px'
export const screenXL = '1200px'
export const screenXXL = '1600px'

export const marginXXS = sizeXXS
export const marginXS = sizeXS
export const marginSM = sizeSM
export const marginBase = sizeBase
export const marginMD = sizeMD
export const marginLG = sizeLG
export const marginXL = sizeXL
export const marginXXL = sizeXXL

export const paddingXXS = sizeXXS
export const paddingXS = sizeXS
export const paddingSM = sizeSM
export const paddingBase = sizeBase
export const paddingMD = sizeMD
export const paddingLG = sizeLG
export const paddingXL = sizeXL
export const paddingMDCompact = '20px'
export const paddingXLCompact = '32px'

export const paddingContentHorizontalSM = sizeBase
export const paddingContentVerticalSM = sizeXS
export const paddingContentHorizontal = sizeMS
export const paddingContentVertical = sizeSM
export const paddingContentHorizontalLG = sizeLG
export const paddingContentVerticalLG = sizeMS

export const fontSizeBase = '14px'
export const fontSizeLG = '16px'
export const fontSizeXS = '10px'
export const fontSizeSM = '12px'
export const fontSizeXL = '20px'
export const fontSizeHeading1 = '38px'
export const fontSizeHeading2 = '30px'
export const fontSizeHeading3 = '24px'
export const fontSizeHeading4 = '20px'
export const fontSizeHeading5 = '16px'
export const fontSizeIcon = '12px'

export const lineHeightBase = '1.57px'
export const lineHeightHeading1 = '1.21px'
export const lineHeightHeading2 = '1.27px'
export const lineHeightHeading3 = '1.33px'
export const lineHeightHeading4 = '1.4px'
export const lineHeightHeading5 = '1.5px'
export const lineHeightLG = '1.5px'
export const lineHeightSM = '1.67px'

/** Namespaced access for call sites migrating off `themeStyle`. */
export const themeConstants = {
  borderRadiusXS,
  borderRadiusXSCompact,
  borderRadiusSM,
  borderRadiusBase,
  borderRadiusLG,
  borderRadiusLGCompact,
  sizeXXS,
  sizeXS,
  sizeSM,
  sizeBase,
  sizeMS,
  sizeMD,
  sizeLG,
  sizeXL,
  sizeXXL,
  controlHeightXS,
  controlHeightSM,
  controlHeight,
  controlHeightLG,
  screenXS,
  screenSM,
  screenMD,
  screenLG,
  screenXL,
  screenXXL,
  marginXXS,
  marginXS,
  marginSM,
  marginBase,
  marginMD,
  marginLG,
  marginXL,
  marginXXL,
  paddingXXS,
  paddingXS,
  paddingSM,
  paddingBase,
  paddingMD,
  paddingLG,
  paddingXL,
  paddingMDCompact,
  paddingXLCompact,
  paddingContentHorizontalSM,
  paddingContentVerticalSM,
  paddingContentHorizontal,
  paddingContentVertical,
  paddingContentHorizontalLG,
  paddingContentVerticalLG,
  fontSizeBase,
  fontSizeLG,
  fontSizeXS,
  fontSizeSM,
  fontSizeXL,
  fontSizeHeading1,
  fontSizeHeading2,
  fontSizeHeading3,
  fontSizeHeading4,
  fontSizeHeading5,
  fontSizeIcon,
  lineHeightBase,
  lineHeightHeading1,
  lineHeightHeading2,
  lineHeightHeading3,
  lineHeightHeading4,
  lineHeightHeading5,
  lineHeightLG,
  lineHeightSM,
} as const

export type ThemeConstantKey = keyof typeof themeConstants
